import { render } from "./GatewayClaimModal.vue?vue&type=template&id=24981c7c"
import script from "./GatewayClaimModal.vue?vue&type=script&lang=js"
export * from "./GatewayClaimModal.vue?vue&type=script&lang=js"
script.render = render

export default script